import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=93869cfc&"
import script from "./Alpha.vue?vue&type=script&lang=js&"
export * from "./Alpha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93869cfc')) {
      api.createRecord('93869cfc', component.options)
    } else {
      api.reload('93869cfc', component.options)
    }
    module.hot.accept("./Alpha.vue?vue&type=template&id=93869cfc&", function () {
      api.rerender('93869cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/colorSelect/Alpha.vue"
export default component.exports